import { ImageProps } from "@fluentui/react-northstar";

export interface ErrorPanelProps {
  description?: string;
  title?: string;
  type?: ErrorPanelType;
  truncateDescription?: boolean;
  imgColorScheme?: ErrorImgColorScheme;
  imgProps?: Omit<ImageProps, "src" | "styles">;
}

export enum ErrorPanelType {
  // Any user or tenant has access related errors.
  AccessError = "accessError",
  // Any user or tenant is blocked from viewing a screen.
  BlockedError = "blockedError",
  // Any external system or service error.
  ExternalError = "externalError",
  // Any other errors or internal service errors.
  GenericError = "genericError",
}

export type ErrorImgColorScheme = "dark" | "light";
